import { Component, inject, input } from '@angular/core';
import { MatCard, MatCardContent, MatCardFooter, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { SbSpinnerComponent } from '../../../components/sb-client/sb-spinner/sb-spinner.component';
import { NgClass } from '@angular/common';
import { AppConfigService } from '../../../services/config/app-config.service';
import { GeneralLoginFlowTestIds } from './general-login-flow.test-ids';

@Component({
  selector: 'app-general-login-flow',
  imports: [MatCard, MatCardHeader, MatCardTitle, MatIcon, MatCardContent, MatCardFooter, SbSpinnerComponent, NgClass],
  templateUrl: './general-login-flow.component.html',
  styleUrl: './general-login-flow.component.scss'
})
/**
 * Begründung: Generic Component for LoginFlow
 */
export class GeneralLoginFlowComponent {
  title = input.required<string>();
  showSpinner = input<boolean>(false);
  keybackup = input<boolean>(false);
  protected readonly testIds = GeneralLoginFlowTestIds;
  protected readonly config: AppConfigService = inject(AppConfigService);
}
